import TLang from "model/application/Lang";

// EN
import enCalendar from "./en/calendar.json";
import enClients from "./en/clients.json";
import enDashboards from "./en/dashboards.json";
import enDetect from "./en/detect.json";
import enDocuments from "./en/documents.json";
import enEnvironment from "./en/environment.json";
import enHome from "./en/home.json";
import enJobs from "./en/jobs.json";
import enLists from "./en/lists.json";
import enLogin from "./en/login.json";
import enMain from "./en/main.json";
import enOrders from "./en/orders.json";
import enPictures from "./en/pictures.json";
import enPlans from "./en/plans.json";
import enTeams from "./en/teams.json";
import enTriggers from "./en/triggers.json";
import enUsers from "./en/users.json";
import enWorkflows from "./en/workflows.json";
// ES
import esCalendar from "./es/calendar.json";
import esClients from "./es/clients.json";
import esDashboards from "./es/dashboards.json";
import esDetect from "./es/detect.json";
import esDocuments from "./es/documents.json";
import esEnvironment from "./es/environment.json";
import esHome from "./es/home.json";
import esJobs from "./es/jobs.json";
import esLists from "./es/lists.json";
import esLogin from "./es/login.json";
import esMain from "./es/main.json";
import esOrders from "./es/orders.json";
import esPictures from "./es/pictures.json";
import esPlans from "./es/plans.json";
import esTeams from "./es/teams.json";
import esTriggers from "./es/triggers.json";
import esUsers from "./es/users.json";
import esWorkflows from "./es/workflows.json";
// FR
import frCalendar from "./fr/calendar.json";
import frClients from "./fr/clients.json";
import frDashboards from "./fr/dashboards.json";
import frDetect from "./fr/detect.json";
import frDocuments from "./fr/documents.json";
import frEnvironment from "./fr/environment.json";
import frHome from "./fr/home.json";
import frJobs from "./fr/jobs.json";
import frLists from "./fr/lists.json";
import frLogin from "./fr/login.json";
import frMain from "./fr/main.json";
import frOrders from "./fr/orders.json";
import frPictures from "./fr/pictures.json";
import frPlans from "./fr/plans.json";
import frTeams from "./fr/teams.json";
import frTriggers from "./fr/triggers.json";
import frUsers from "./fr/users.json";
import frWorkflows from "./fr/workflows.json";
// PT
import ptCalendar from "./pt/calendar.json";
import ptClients from "./pt/clients.json";
import ptDashboards from "./pt/dashboards.json";
import ptDetect from "./pt/detect.json";
import ptDocuments from "./pt/documents.json";
import ptEnvironment from "./pt/environment.json";
import ptHome from "./pt/home.json";
import ptJobs from "./pt/jobs.json";
import ptLists from "./pt/lists.json";
import ptLogin from "./pt/login.json";
import ptMain from "./pt/main.json";
import ptOrders from "./pt/orders.json";
import ptPictures from "./pt/pictures.json";
import ptPlans from "./pt/plans.json";
import ptTeams from "./pt/teams.json";
import ptTriggers from "./pt/triggers.json";
import ptUsers from "./pt/users.json";
import ptWorkflows from "./pt/workflows.json";
// VI
import viCalendar from "./vi/calendar.json";
import viClients from "./vi/clients.json";
import viDashboards from "./vi/dashboards.json";
import viDetect from "./vi/detect.json";
import viDocuments from "./vi/documents.json";
import viEnvironment from "./vi/environment.json";
import viHome from "./vi/home.json";
import viJobs from "./vi/jobs.json";
import viLists from "./vi/lists.json";
import viLogin from "./vi/login.json";
import viMain from "./vi/main.json";
import viOrders from "./vi/orders.json";
import viPictures from "./vi/pictures.json";
import viPlans from "./vi/plans.json";
import viTeams from "./vi/teams.json";
import viTriggers from "./vi/triggers.json";
import viUsers from "./vi/users.json";
import viWorkflows from "./vi/workflows.json";

type TLangMainPart = Omit<TLang, "plans" | "containers">;

const buildLang = (
  main: unknown,
  plans: unknown,
  containers: Record<string, unknown>,
): TLang => {
  const mainPart = main as TLangMainPart;

  return {
    ...mainPart,
    plans: (plans as { plans: TLang["plans"] }).plans,
    containers: containers as TLang["containers"],
  };
};

const en = buildLang(enMain, enPlans, {
  calendar: enCalendar,
  clients: enClients,
  dashboards: enDashboards,
  detect: enDetect,
  documents: enDocuments,
  environment: enEnvironment,
  home: enHome,
  jobs: enJobs,
  lists: enLists,
  login: enLogin,
  orders: enOrders,
  pictures: enPictures,
  teams: enTeams,
  triggers: enTriggers,
  users: enUsers,
  workflows: enWorkflows,
});

const es = buildLang(esMain, esPlans, {
  calendar: esCalendar,
  clients: esClients,
  dashboards: esDashboards,
  detect: esDetect,
  documents: esDocuments,
  environment: esEnvironment,
  home: esHome,
  jobs: esJobs,
  lists: esLists,
  login: esLogin,
  orders: esOrders,
  pictures: esPictures,
  teams: esTeams,
  triggers: esTriggers,
  users: esUsers,
  workflows: esWorkflows,
});

const fr = buildLang(frMain, frPlans, {
  calendar: frCalendar,
  clients: frClients,
  dashboards: frDashboards,
  detect: frDetect,
  documents: frDocuments,
  environment: frEnvironment,
  home: frHome,
  jobs: frJobs,
  lists: frLists,
  login: frLogin,
  orders: frOrders,
  pictures: frPictures,
  teams: frTeams,
  triggers: frTriggers,
  users: frUsers,
  workflows: frWorkflows,
});

const pt = buildLang(ptMain, ptPlans, {
  calendar: ptCalendar,
  clients: ptClients,
  dashboards: ptDashboards,
  detect: ptDetect,
  documents: ptDocuments,
  environment: ptEnvironment,
  home: ptHome,
  jobs: ptJobs,
  lists: ptLists,
  login: ptLogin,
  orders: ptOrders,
  pictures: ptPictures,
  teams: ptTeams,
  triggers: ptTriggers,
  users: ptUsers,
  workflows: ptWorkflows,
});

const vi = buildLang(viMain, viPlans, {
  calendar: viCalendar,
  clients: viClients,
  dashboards: viDashboards,
  detect: viDetect,
  documents: viDocuments,
  environment: viEnvironment,
  home: viHome,
  jobs: viJobs,
  lists: viLists,
  login: viLogin,
  orders: viOrders,
  pictures: viPictures,
  teams: viTeams,
  triggers: viTriggers,
  users: viUsers,
  workflows: viWorkflows,
});

export { en, es, fr, pt, vi };
